<div class="card card-box mb-5">
    <div class="row no-gutters">
        <div class="col-xl-5">
            <div class="hero-wrapper bg-composed-wrapper bg-plum-plate h-100 rounded-left">
                <div class="flex-grow-1 w-100 d-flex align-items-center">
                    <div class="bg-composed-wrapper--image rounded-left"
                         style="background-image: url('assets/images/hero-bg/hero-1.jpg');"></div>
                    <div class="bg-composed-wrapper--bg bg-second opacity-5 rounded-left"></div>
                    <div class="bg-composed-wrapper--content p-5">
                        <div class="d-flex align-items-center">
                            <span class="badge badge-pill badge-second px-4 h-auto py-1">New release</span>
                            <span class="text-white-50 pl-3" placement="right" tooltip="More info placeholder!">
                                <fa-icon [icon]="['far', 'question-circle']"></fa-icon>
                            </span>
                        </div>
                        <div class="text-white mt-3">
                            <h1 class="display-4 my-3 font-weight-bold">
                                Wonderful serenity has possession
                            </h1>
                            <p class="font-size-md mb-0 text-white-50">
                                A free hour, when our power of choice is untrammelled and when nothing prevents.
                            </p>
                            <div class="divider border-2 my-5 border-light opacity-2 rounded w-25"></div>
                            <div>
                                <a [routerLink]="" class="btn btn-warning">
                                    <span class="btn-wrapper--label">
                                        Browse gallery
                                    </span>
                                    <span class="btn-wrapper--icon">
                                        <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hero-footer pb-4">
                    <ul class="nav">
                        <li class="nav-item">
                            <a [routerLink]="" class="btn btn-link px-2 py-1 font-size-xl text-white-50"
                              tooltip="Facebook">
                                <fa-icon [icon]="['fab', 'facebook']"></fa-icon>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="btn btn-link px-2 py-1 font-size-xl text-white-50"
                              tooltip="Twitter">
                                <fa-icon [icon]="['fab', 'twitter']"></fa-icon>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="btn btn-link px-2 py-1 font-size-xl text-white-50"
                              tooltip="Google">
                                <fa-icon [icon]="['fab', 'google']"></fa-icon>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="btn btn-link px-2 py-1 font-size-xl text-white-50"
                              tooltip="Instagram">
                                <fa-icon [icon]="['fab', 'instagram']"></fa-icon>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col-xl-7">
            <tabset class="tabs-animated p-4 tabs-animated-line" type="tabs">
                <tab>
                    <ng-template tabHeading>
                        <span>Overview</span>
                    </ng-template>
                    <div class="px-1 py-5">
                        <div class="row">
                            <div class="col-xl-4">
                                <div class="card card-box text-black-50 mb-5 p-3">
                                    <div class="display-3 text-black font-weight-bold">
                                        31
                                    </div>
                                    <div class="divider mt-2 mb-3 border-2 w-25 bg-first rounded border-first"></div>
                                    <div class="font-weight-bold font-size-sm text-uppercase">
                                        Implemented
                                        <br>
                                        bugfixes
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4">
                                <div class="card card-box text-black-50 mb-5 p-3">
                                    <div class="display-3 text-black font-weight-bold">
                                        68
                                    </div>
                                    <div class="divider mt-2 mb-3 border-2 w-25 bg-success rounded border-success"></div>
                                    <div class="font-weight-bold font-size-sm text-uppercase">
                                        Unresolved
                                        <br>
                                        tickets
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4">
                                <div class="card card-box text-black-50 mb-5 p-3">
                                    <div class="display-3 text-black font-weight-bold">
                                        57
                                    </div>
                                    <div class="divider mt-2 mb-3 border-2 w-25 bg-warning rounded border-warning"></div>
                                    <div class="font-weight-bold font-size-sm text-uppercase">
                                        Support
                                        <br>
                                        requests
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card card-box mb-5">
                            <div class="card-body">
                                <div class="text-left">
                                    <div class="mt-1">
                                        <fa-icon [icon]="['fas', 'lemon']" class="font-size-xxl text-danger"></fa-icon>
                                    </div>
                                    <div class="mt-3 line-height-sm">
                                        <b class="font-size-lg text-black">3,568</b>
                                        <span class="text-black-50 pl-1">clicks</span>
                                    </div>
                                </div>
                                <div class="progress mt-3">
                                    <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="15" class="progress-bar"
                                         role="progressbar" style="width: 15%"></div>
                                    <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="30"
                                         class="progress-bar bg-success" role="progressbar" style="width: 30%"></div>
                                    <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="20"
                                         class="progress-bar bg-info"
                                         role="progressbar" style="width: 20%"></div>
                                </div>
                            </div>
                        </div>
                        <button class="btn btn-outline-primary mt-2" type="button">
                            Create new report
                        </button>
                    </div>
                </tab>
                <tab>
                    <ng-template tabHeading>
                        <span>Sign in</span>
                    </ng-template>
                    <div class="card m-0 shadow-none border-0 my-5 mx-1">
                        <div class="card-header d-block p-3 pt-0 rounded bg-light">
                            <div class="text-muted text-center mb-3">
                                <small>Sign in with</small>
                            </div>
                            <div class="text-center">
                                <button class="btn btn-facebook mr-2" type="button">
                                    <span class="btn-wrapper--icon">
                                        <fa-icon [icon]="['fab', 'facebook']"></fa-icon>
                                    </span>
                                    <span class="btn-wrapper--label">
                                        Facebook
                                    </span>
                                </button>
                                <button class="btn btn-twitter ml-2" type="button">
                                    <span class="btn-wrapper--icon">
                                        <fa-icon [icon]="['fab', 'twitter']"></fa-icon>
                                    </span>
                                    <span class="btn-wrapper--label">
                                        Twitter
                                    </span>
                                </button>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="text-center text-muted mb-3">
                                <small>Or sign in with credentials</small>
                            </div>
                            <form role="form">
                                <div class="form-group mb-3">
                                    <div class="input-group input-group-alternative">
                                        <div class="input-group-prepend">
                                                    <span class="input-group-text">
                                                        <fa-icon [icon]="['far', 'envelope']"></fa-icon>
                                                    </span>
                                        </div>
                                        <input class="form-control" placeholder="Email" type="email">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="input-group input-group-alternative">
                                        <div class="input-group-prepend">
                                                        <span class="input-group-text">
                                                            <fa-icon [icon]="['fas', 'unlock-alt']"></fa-icon>
                                                        </span>
                                        </div>
                                        <input class="form-control" placeholder="Password" type="password">
                                    </div>
                                </div>
                                <div class="custom-control custom-control-alternative custom-checkbox">
                                    <input class="custom-control-input" id=" customCheckLogin" type="checkbox">
                                    <label class="custom-control-label" for=" customCheckLogin">
                                        <span>Remember me</span>
                                    </label>
                                </div>
                                <div class="text-center">
                                    <button class="btn btn-second my-2" type="button">Sign in</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </tab>
                <tab>
                    <ng-template tabHeading>
                        <span>Recent activity</span>
                    </ng-template>
                    <div class="py-5 px-1">
                        <div class="row">
                            <div class="col-xl-6">
                                <div class="card card-box mb-5">
                                    <div class="card-indicator bg-first"></div>
                                    <div class="card-body px-4 py-3">
                                        <div class="pb-3 d-flex justify-content-between">
                                            <a [routerLink]="">
                                                Presentation site design
                                            </a>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-start">
                                            <div class="badge badge-first px-3">On hold</div>
                                            <div class="font-size-sm text-danger px-2">
                                                <fa-icon [icon]="['far', 'clock']" class="mr-1"></fa-icon>
                                                14:22
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6">
                                <div class="card card-box mb-5">
                                    <div class="card-indicator bg-success"></div>
                                    <div class="card-body px-4 py-3">
                                        <div class="pb-3 d-flex justify-content-between">
                                            <a [routerLink]="">
                                                Create UI mockups
                                            </a>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-start">
                                            <div class="badge badge-success px-3">Fixed</div>
                                            <div class="font-size-sm text-dark px-2">
                                                <fa-icon [icon]="['far', 'clock']" class="mr-1"></fa-icon>
                                                09:41
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="timeline-list">
                            <div class="timeline-item timeline-item-icon">
                                <div class="timeline-item--content">
                                    <div class="timeline-item--icon-wrapper bg-danger text-white">
                                        <fa-icon [icon]="['far', 'gem']"></fa-icon>
                                    </div>
                                    <h4 class="timeline-item--label mb-2 font-weight-bold">1998</h4>
                                    <p>
                                        Bill Clinton's presidential scandal makes it online.
                                    </p>
                                </div>
                            </div>
                            <div class="timeline-item">
                                <div class="timeline-item--content">
                                    <div class="timeline-item--icon"></div>
                                    <h4 class="timeline-item--label mb-2 font-weight-bold">Java exam day</h4>
                                    <p>
                                        Bill Clinton's presidential scandal makes it online.
                                    </p>
                                    <div class="avatar-wrapper-overlap mt-2 mb-1">
                                        <div class="avatar-icon-wrapper avatar-icon-sm">
                                            <div class="avatar-icon"><img alt="..."
                                                                          src="assets/images/avatars/avatar1.jpg"/>
                                            </div>
                                        </div>
                                        <div class="avatar-icon-wrapper avatar-icon-sm">
                                            <div class="avatar-icon"><img alt="..."
                                                                          src="assets/images/avatars/avatar7.jpg"/>
                                            </div>
                                        </div>
                                        <div class="avatar-icon-wrapper avatar-icon-sm">
                                            <div class="avatar-icon"><img alt="..."
                                                                          src="assets/images/avatars/avatar1.jpg"/>
                                            </div>
                                        </div>
                                        <div class="avatar-icon-wrapper avatar-icon-sm">
                                            <div class="avatar-icon"><img alt="..."
                                                                          src="assets/images/avatars/avatar2.jpg"/>
                                            </div>
                                        </div>
                                        <div class="avatar-icon-wrapper avatar-icon-sm">
                                            <div class="avatar-icon"><img alt="..."
                                                                          src="assets/images/avatars/avatar6.jpg"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="timeline-item">
                                <div class="timeline-item--content">
                                    <div class="timeline-item--icon"></div>
                                    <h4 class="timeline-item--label mb-2 font-weight-bold">
                                        Business investor meeting
                                        <span class="badge badge-neutral-info text-info ml-2">New</span>
                                    </h4>
                                    <p>
                                        Mosaic, the first graphical browser, is introduced to the average consumer.
                                    </p>
                                    <div class="mt-2">
                                        <button class="btn btn-sm btn-primary" type="button">Submit Report</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </tab>
            </tabset>
        </div>
    </div>
</div>
